import Rollup from "../singleton/rollup";

export default {

    getLabelFields: Rollup.getLabelFields.bind(Rollup),

    getFilterFields: Rollup.getFilterFields.bind(Rollup)

}